import { connect } from 'react-redux';
import { getInputDataToSend, getPanels } from '../../../../store/form/selectors';
import { fetchProductsData } from '../../../../store/products/actions';
import { fetchProductsBySection, setInputDataToSend } from '../../../../store/form/actions';
import PanelSection from './PanelSection';
import { getLoader } from '../../../../store/loader/selectors';

const mapStateToProps = (state) => ({
  loader: getLoader(state),
  panels: getPanels(state),
  inputData: getInputDataToSend(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchProductsData: () => dispatch(fetchProductsData()),
  fetchProductsBySection: (
    fetchSettings,
  ) => {
    dispatch(fetchProductsBySection(
      fetchSettings,
    ));
  },
  setInputDataToSend: (key, data) => {
    dispatch(setInputDataToSend(key, data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelSection);
